var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "system-container" }, [
      _c("div", { staticClass: "questionnaire-edit" }, [
        _c("div", { staticClass: "area-title" }, [
          _vm._v(
            "\n        " +
              _vm._s(Object.keys(_vm.editFormRecord).length ? "编辑" : "新增") +
              "题目区域\n      "
          ),
        ]),
        _c(
          "div",
          { staticClass: "form-area" },
          [
            _vm.showQueTableStatus
              ? _c(_vm.currFormType, {
                  tag: "component",
                  attrs: {
                    evaluationId: _vm.evaluationId,
                    insertNum: _vm.insertNum,
                    editFormRecord: _vm.editFormRecord,
                  },
                  on: {
                    cancelEdit: _vm.cancelEdit,
                    refreshData: _vm.refreshData,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "questionnaire-list" },
        [
          _c("div", { staticClass: "area-title" }, [
            _vm._v("题目列表/预览区域"),
          ]),
          _c(
            "a-tabs",
            { attrs: { "default-active-key": "1" } },
            [
              _c(
                "a-tab-pane",
                { key: "1" },
                [
                  _c(
                    "span",
                    { attrs: { slot: "tab" }, slot: "tab" },
                    [
                      _c("a-icon", { attrs: { type: "apple" } }),
                      _vm._v("\n            列表预览\n          "),
                    ],
                    1
                  ),
                  _vm.showQueTableStatus
                    ? _c("QuestionTable", {
                        attrs: {
                          evaluationId: _vm.evaluationId,
                          dataSource: _vm.dataSource,
                        },
                        on: {
                          editForm: _vm.editForm,
                          insertionForm: _vm.insertionForm,
                          refreshData: _vm.refreshData,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "2" },
                [
                  _c(
                    "span",
                    { attrs: { slot: "tab" }, slot: "tab" },
                    [
                      _c("a-icon", { attrs: { type: "android" } }),
                      _vm._v("\n            量表预览\n          "),
                    ],
                    1
                  ),
                  _c("QuesPreview", {
                    staticClass: "scroll-area",
                    attrs: { dataSource: _vm.dataSource },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fixed-btn-area" },
        [
          _c(
            "a-popconfirm",
            {
              attrs: { "ok-text": "是", "cancel-text": "否" },
              on: {
                confirm: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("template", { slot: "title" }, [
                _c("p", [
                  _vm._v("新增问卷模式下，取消操作会导致未保存的表单内容丢失"),
                ]),
                _c("p", [_vm._v("确认要取消吗？")]),
              ]),
              _c("a-button", [_vm._v("取消")]),
            ],
            2
          ),
          _c(
            "a-button",
            {
              staticStyle: { margin: "0px 12px" },
              on: { click: _vm.prevClick },
            },
            [_vm._v("上一步")]
          ),
          _c("a-button", { on: { click: _vm.nextClick } }, [_vm._v("下一步")]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }